import DropDown from './DropDown';
import ErrorMessage from './ErrorMessage';
import TextInput from './TextInput';

export default function Contact({
	children,
	block,
	state,
	errorMessages,
	setNestedValue,
	showErrors,
	...props
}) {
	const { properties } = block;
	const {
		title = {},
		name = {},
		email = {},
		phone = {},
		phone2 = {}
	} = properties.elements ?? {};

	return (
		<div class="contact-wrapper">
			{title.show && (
				<div className="title-wrapper">
					<div>
						<DropDown
							block={title}
							state={state[title.data_field]}
							setValue={value => setNestedValue(title.data_field, value)}
							showErrors={showErrors}
						/>
						{state[title.data_field].showError && (
							<ErrorMessage
								id={`error-message-${title.data_field}`}
								showErrors={showErrors}
							>
								{errorMessages[title.data_field]}
							</ErrorMessage>
						)}
					</div>
				</div>
			)}
			{name.show && name.combine && (
				<div className="name-wrapper">
					<div>
						<TextInput
							block={{ ...name, typeName: block.typeName }}
							state={state[name.data_field]}
							setValue={value => setNestedValue(name.data_field, value)}
							showErrors={showErrors}
						/>
						{state[name.data_field].showError && (
							<ErrorMessage
								id={`error-message-${name.data_field}`}
								showErrors={showErrors}
							>
								{errorMessages[name.data_field]}
							</ErrorMessage>
						)}
					</div>
				</div>
			)}
			{name.show && !name.combine && (
				<div className="name-wrapper">
					<div>
						<TextInput
							block={{ ...name.subelements.firstname, typeName: block.typeName }}
							state={state[name?.subelements?.firstname?.data_field]}
							setValue={value =>
								setNestedValue(name?.subelements?.firstname?.data_field, value)
							}
							showErrors={showErrors}
						/>
						{state[name?.subelements?.firstname?.data_field]?.showError && (
							<ErrorMessage
								id={`error-message-${name?.subelements?.firstname?.data_field}`}
								showErrors={showErrors}
							>
								{errorMessages[name?.subelements?.firstname?.data_field]}
							</ErrorMessage>
						)}
					</div>
					<div>
						<TextInput
							block={{ ...name.subelements.lastname, typeName: block.typeName }}
							state={state[name?.subelements?.lastname?.data_field]}
							setValue={value =>
								setNestedValue(name?.subelements?.lastname?.data_field, value)
							}
							showErrors={showErrors}
						/>
						{state[name?.subelements?.lastname?.data_field]?.showError && (
							<ErrorMessage
								id={`error-message-${name?.subelements?.lastname?.data_field}`}
								showErrors={showErrors}
							>
								{errorMessages[name?.subelements?.lastname?.data_field]}
							</ErrorMessage>
						)}
					</div>
				</div>
			)}
			{email.show && (
				<div className="email-wrapper">
					<div>
						<TextInput
							block={{ ...email, typeName: block.typeName }}
							state={state[email.data_field]}
							setValue={value => setNestedValue(email.data_field, value)}
							type="email"
							showErrors={showErrors}
						/>
						{state[email.data_field].showError && (
							<ErrorMessage
								id={`error-message-${email.data_field}`}
								showErrors={showErrors}
							>
								{errorMessages[email.data_field]}
							</ErrorMessage>
						)}
					</div>
				</div>
			)}
			{phone.show && (
				<div className="phone-wrapper">
					<div>
						<TextInput
							block={{ ...phone, typeName: block.typeName }}
							state={state[phone.data_field]}
							setValue={value => setNestedValue(phone.data_field, value)}
							type="tel"
							showErrors={showErrors}
						/>
						{state[phone.data_field].showError && (
							<ErrorMessage
								id={`error-message-${phone.data_field}`}
								showErrors={showErrors}
							>
								{errorMessages[phone.data_field]}
							</ErrorMessage>
						)}
					</div>
				</div>
			)}
			{phone2.show && (
				<div className="phone-wrapper">
					<div>
						<TextInput
							block={{ ...phone2, typeName: block.typeName }}
							state={state[phone2.data_field]}
							setValue={value => setNestedValue(phone2.data_field, value)}
							type="tel"
							showErrors={showErrors}
						/>
						{showErrors && state[phone2.data_field].showError && (
							<ErrorMessage showErrors={showErrors}>
								{errorMessages[phone2.data_field]}
							</ErrorMessage>
						)}
					</div>
				</div>
			)}
		</div>
	);
}
